module.exports = __webpack_public_path__ + "img/1532264911.9b0a6cdf.jpg";